import React from 'react';

// margen: ancho del panel de edición abierto, para que la vista previa ocupe el resto
const PreviewSitio = ({ iframeRef, src, titulo, encabezado, ayuda, acciones, margen = 0, children }) => (
    <div id='vistas_generales' className='col s12' style={{padding:"0", width: margen ? `calc(100% - ${margen}px)` : undefined}}>
        <div className='preview_contenedor'>
            <div className='preview_barra'>
                <div>
                    <p className='preview_barra_etiqueta'>Sección del sitio</p>
                    <p className='preview_barra_titulo'>{encabezado}</p>
                    {ayuda && <p className='preview_barra_ayuda'>{ayuda}</p>}
                </div>
                <div className='preview_barra_acciones'>
                    {acciones}
                </div>
            </div>
            <iframe ref={iframeRef} src={src} title={titulo} className='preview_iframe' />
        </div>
        {children}
    </div>
);

export default PreviewSitio;
